/**
 * Product inventory status: follow the selected variant.
 *
 * The inventory_status block in sections/main-product.liquid is rendered for
 * the variant selected on load. The variant picker updates price, badges and
 * the buy button itself and then dispatches `variant:changed`; nothing
 * listened for it here, so the stock line kept showing the first variant.
 *
 * Each block carries its own JSON of variant stock ({ id: { available,
 * managed, quantity } }), since the picker's variant JSON has no quantities.
 * The status rules match the Liquid: unmanaged stock reads In stock unless
 * the variant is unavailable; managed stock at or under the block's
 * threshold reads Low stock.
 */
(() => {
  if (window.__productInventoryStatus) return;
  window.__productInventoryStatus = true;

  const readStock = (block) => {
    if (block.__stock) return block.__stock;
    const json = block.querySelector('[data-inventory-json]');
    try {
      block.__stock = json ? JSON.parse(json.textContent) : {};
    } catch (error) {
      block.__stock = {};
    }
    return block.__stock;
  };

  const statusFor = (stock, threshold) => {
    if (!stock.available) return 'out';
    if (stock.managed && typeof stock.quantity === 'number' && stock.quantity <= threshold) return 'low';
    return 'in';
  };

  const update = (block, variantId) => {
    const stock = readStock(block)[String(variantId)];
    if (!stock) return;

    const threshold = Number(block.dataset.threshold) || 10;
    const status = statusFor(stock, threshold);
    const style = block.dataset.inventoryStyle;
    const labels = { in: block.dataset.labelIn, low: block.dataset.labelLow, out: block.dataset.labelOut };

    block.dataset.inventoryStatus = status;

    const label = block.querySelector('[data-inventory-label]');
    if (label) label.textContent = labels[status] || '';

    const dot = block.querySelector('[data-inventory-dot]');
    if (dot) {
      dot.classList.remove('product-block__inventory-dot--in', 'product-block__inventory-dot--low', 'product-block__inventory-dot--out');
      dot.classList.add(`product-block__inventory-dot--${status}`);
    }

    const count = block.querySelector('[data-inventory-count]');
    if (count) {
      const showCount = block.dataset.showCount === 'true'
        && stock.managed
        && typeof stock.quantity === 'number'
        && status !== 'out'
        && (style === 'bar' || status === 'low');
      const text = `${stock.quantity} ${block.dataset.labelLeft || 'left'}`;
      count.textContent = showCount ? (style === 'bar' ? text : `, ${text}`) : '';
      count.hidden = !showCount;
    }
  };

  document.addEventListener('variant:changed', (event) => {
    const variant = event.detail && event.detail.variant;
    if (!variant || variant.id == null) return;

    // The picker dispatches on its section and again on the document; act
    // once, on the blocks inside the section that changed.
    const sectionId = event.detail.sectionId;
    const scope = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : null;
    if (event.currentTarget === document && event.target !== document && scope) return;

    (scope || document).querySelectorAll('[data-inventory-block]').forEach((block) => update(block, variant.id));
  });
})();
